<template>
  <div class="partner">
    <div class="bgBanner">
      <img src="../assets/partner/bg_top.png" alt="">
      <div class="head-content">
        <div class="title">精诚合作，共赢未来</div>
        <div>成为蓝凌智能OA合作伙伴，共同助力中小企业成长的每个阶段</div>
        <div class="apply" @click="goMid">申请入驻</div>
      </div>
    </div>
    <div class="support">
      <h3>6大支持助力营收</h3>
      <p>为更好地分享企业数字化转型、SAAS-OA蓝海，共掘千亿级企业市场带来的红利，蓝凌整合19年大客户服务和渠道合作的经验，面向全国城市招募蓝凌智能OA合作伙伴，全方位的合作与支持，帮助伙伴获得持续经营与持续收益，并与阿里钉钉共同成长。</p>
      <div class="supportList">
        <div class="supportItem" v-for="(item,index) in supportList" :key='index'>
          <div class="itemHead"><img :src="item.img" alt=""></div>
          <p class="itemTitle">{{item.title}}</p>
          <p class="itemContent">{{item.content}}</p>
        </div>
      </div>
    </div>
    <!-- <div class="mid"  id="mid"><div>申请入驻</div></div>
    <div class="register">
      <div class="form">
        <div>
          <span><span class="tips">*</span>企业名称</span>
          <input type="text" v-model="conName" maxlength="50">
        </div>
        <div>
          <span><span class="tips">*</span>所在城市</span>
          <area-cascader type='all' v-model="selectValue" :level='1' :data="pcaa"></area-cascader>
        </div>
        <div>
          <span><span class="tips">*</span>联系人</span>
          <input type="text" v-model="contacts" maxlength="50">
        </div>
        <div>  
          <span><span class="tips">*</span>联系方式</span>
          <input type="text" v-model="telephone">
        </div>
      </div>
      <div  @click="goApply" class="goApply">提交申请</div>
      <p class="detail">
        蓝凌的渠道扶持策略确保合作伙伴“快速成长、标准合规、最高盈利”，持续秉承“伙伴优先”的渠道文化，蓝凌为伙伴提供足够的资源，保证足够的利润，与伙伴一起成长，共赢未来。
      </p>
      <div  class="message" v-if="succ">
          <div><img src="../assets/partner/succ.png" alt=""></div>
          <p>{{succ}}</p>
      </div>
      <div  class="message" v-if="fail">
          <div><img src="../assets/partner/fail.png" alt=""></div>
          <p>{{fail}}</p>
      </div>
      <div  class="message" v-if="isKong">
          <p>{{isKong}}</p>
      </div>

    </div> -->
  </div>
</template>

<script>
import icon1 from '../assets/partner/icon1.png'
import icon2 from '../assets/partner/icon2.png'
import icon3 from '../assets/partner/icon3.png'
import icon4 from '../assets/partner/icon4.png'
import icon5 from '../assets/partner/icon5.png'
import icon6 from '../assets/partner/icon6.png'
import { pcaa } from 'area-data';
export default {
  data() {
    return {
      supportList:[
        {
          title:'组织赋能：助力培训新人，打造铁军',
          content:'共享蓝凌、钉钉组织文化资源，帮你快速培训新人，打造高效协作铁军',
          img:icon1
        },
        {
          title:'市场赋能：共享推广资源，共创商机',
          content:'共享蓝凌全媒体推广资源、支持伙伴区域市场活动、分配高质量的商机',
          img:icon2
        },
        {
          title:'产品赋能：蓝凌x阿里钉钉联合产品',
          content:'整合蓝凌、阿里钉钉产品优势，引领创新，下沉行业，传递高附加值产品',
          img:icon3
        },
        {
          title:'运营赋能：专业培训，助力快速赢单',
          content:'通过破冰培训、运营陪练、售前陪访等，亲手教你快速赢单、交付收款',
          img:icon4
        },
        {
          title:'服务赋能：快速响应确保持续经营',
          content:'钉钉服务群实时连接、快速响应、老客户持续经营，让满意度、利润有保障',
          img:icon5
        },
        {
          title:'生态赋能：共享人脉和客户资源',
          content:'完善行业及服务伙伴的布局，共享生态人脉、客户资源，共创生态价值',
          img:icon6
        },
      ],
      pcaa:pcaa,
      selectValue:'',
      conName:'',
      contacts:'',
      telephone:'',
      succ:'',
      fail:'',
      isKong:''
    };
  },
  methods:{
    goMid(){
      _czc.push(["_trackEvent", "申请入驻", "button"]);
      window.open('https://jinshuju.net/f/nbkg8B')
    },
    goApply(){
      var address = ''
      for(let i = 0;i<this.selectValue.length; i++){
        for (var j in this.selectValue[i]) {
          address += this.selectValue[i][j].toString()
        }
      }
      if(this.isEmpty(this.conName)){
        this.isKong = '请填写企业名称'
        setTimeout(() => {
          this.isKong = ''
        }, 2000);
        return
      }else if(this.isEmpty(address)){
        this.isKong = '请选择地址'
        setTimeout(() => {
          this.isKong = ''
        }, 2000);
        return
      }else if(this.isEmpty(this.contacts)){
        this.isKong = '请填写联系人'
        setTimeout(() => {
          this.isKong = ''
        }, 2000);
        return
      }else if(this.isEmpty(this.telephone)){
        this.isKong = '请填写联系方式'
        setTimeout(() => {
          this.isKong = ''
        }, 2000);
        return
      }
      var obj = {
        "corp_name":this.conName,
        "city":address,
        "contact":this.contacts,
        "phone":this.telephone
      }
      this.$ajax({
        method:'POST',
        url:'https://ding.dingteam.com/operation/f4/apply',
        // url:'https://test-activity.dingteam.com/operation/f4/apply',//测试
        data:obj
      }).then(res=>{
        if(res.data.errCode == 0){
          this.succ = res.data.msg
          setTimeout(() => {
            this.succ = '' 
          }, 2000);
        }else{
          this.fail = res.data.msg
          setTimeout(() => {
            this.fail = '' 
          }, 2000);
        }
      })
    },

    isEmpty(value){
      if (value == null || value.replace(/(^\s*)|(\s*$)/g, "") == "") return true
      else return false
    },
    isTel(value){
      var rex = /^1[345789]\d{9}$/;
      return rex.test(value);
    },
  },
  created(){
 
  }
};
</script>

<style lang="less" scoped>
img{width: 100%;height: 100%}
.partner{
  padding-top:70px;
  position: relative;
  font-family: MicrosoftYaHeiUILight;
  .bgBanner{
    width: 100%;
    height: 800px;
    .head-content{
      position: absolute;
      top: 222px;
      left: 0;
      width: 100%;
      font-size: 26px;
      color: #FFFFFF;
      text-align: center;
      .title{
        font-size: 58px;
        margin-bottom: 40px;
      }
      .apply{
        display: inline-block;
        background: #4285F4;
        color: #FFFFFF;
        border-radius: 31px;
        height: 62px;
        line-height: 62px;
        padding: 0 42px;
        margin-top:60px; 
        cursor: pointer;
      }
    }
  }
  .support{
    padding-top: 100px;
    h3{
      font-size: 24px;
      color: #333333;
      font-weight: normal;
      width: 100%;
      text-align: center;
    }
    p{
      text-align: center;
    }
    >p{
      width: 1000px;
      line-height: 2;
      margin: 30px auto 100px auto;
    }
    .supportList{
      width: 1040px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      p{
        line-height: 1.5
      }
      .supportItem{
        width: 288px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-bottom: 94px;
        .itemHead{
          width: 64px;
          height: 64px;
        } 
        .itemTitle{
          font-size: 18px;
          color: #333333;
          text-align: center;
          margin: 15px 0;
        }
      }
    }
  }
  .mid{
    height: 120px;
    width: 100%;
    margin-top:120px;
    background-image: url('../assets/partner/bg_mid.png');
    background-size: 100% 100%;
    div{
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #FFFFFF;
      text-align: center;
      line-height: 120px;
    }
  }
  .register{
    height: 720px;
    background: url('../assets/partner/bg_foot.png');
    background-size: 100% 100%;
    position: relative;
    .form{
      padding: 80px 0 15px 0;
      font-size: 18px;
      color: #151515;
      input{
        height: 32px;
        border: none;
        border-bottom: 1px solid #D8D8D8;
        width: 450px;
        background-color: transparent;
        margin-left: 20px;
        font-size: 16px;
        color: #151515;
        padding-left: 12px;
        outline: none;

      }
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 60px;
        >span{
          text-align: right;
          width: 90px;
          .tips{
            color: #FF2D2D;
            margin-right: 5px;
          }
        }
      }
    }
    .goApply{
      width: 148px;height:  48px;
      border: 1px solid #4285F4;
      border-radius: 24px;
      font-size: 18px;
      color: #4285F4;
      text-align: center;
      line-height: 48px;
      text-shadow: 0 2px 17px rgba(255,255,255,0.13);
      margin: 0 auto;
      cursor: pointer;
      &:hover{
        animation: bganimate 0.5s forwards;
        color:white;
        border:none;
      }
    }
    .detail{
      font-size: 14px;
      color: #666666;
      text-align: center;
      width: 637px;
      margin: 0 auto;
      margin-top: 100px;
      line-height: 2
    }
    .message{
      font-size: 20px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 440px;
      height: 72px;
      left: 50%;
      top:50%; 
      margin-left: -220px;
      margin-top: -36px;
      background: #FFFFFF;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      border-radius: 6px;
      img{
        width: 38px;
        height: 38px;
        margin-right: 20px;
      }
    }
  }
}

@keyframes bganimate {
    from {
      background: white;
    }
    to{
      background:#4285F4;
    }
}

</style>

<style>
.area-cascader-wrap{
  width: 450px!important;
  margin-left: 20px!important;
}
.area-select{
  background: transparent!important;
  border: none!important;
  border-bottom: 1px solid #D8D8D8!important;
  width: 450px!important;
  border-radius: 0!important;
}
.area-select .area-selected-trigger{
  width: 450px!important;
  font-size: 16px!important;
  color: #151515!important;
}
.cascader-menu-list-wrap{
  /* background-color: #eee; */
  border: none!important;
  margin:0!important
}
.cascader-menu-list{
  /* background-color: #eee; */
  padding: 0!important;
  color: #ADAFBE!important;
}
.cascader-menu-list .cascader-menu-option.selected{
  color:#4285F4!important
}
.cascader-menu-list .cascader-menu-option.selected{
  background-color: #EAEBF0!important;
}
</style>


// WEBPACK FOOTER //
// src/pages/partner.vue